export default __webpack_public_path__ + "img/jtc/jtc8_1500.jpg";